import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { memo } from "react";
import { MultiselectKeys } from "~/components/MultiselectKeys";
import { useMouseSelection } from "~/hooks/useMouseSelection";
export const MouseSelectionContainer = /*#__PURE__*/ memo((param)=>{
    let { children, containerRef, itemsPositions, scrollElementRef, minSelectionTopPosition } = param;
    const { DragSelection } = useMouseSelection({
        containerRef,
        rowsPositions: itemsPositions,
        scrollElementRef,
        minSelectionTopPosition
    });
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(DragSelection, {}),
            children,
            /*#__PURE__*/ _jsx(MultiselectKeys, {})
        ]
    });
});
MouseSelectionContainer.displayName = "MouseSelectionContainer";
